<template>
  <div class="objectives" id="info">
    <b-card title="Summary of ThermoML Archive data points through 2019 for all cooperating journals" class="text-left m-1">
    <b-card-text>
              The ThermoML Archive includes data through 2019 for all cooperating journals as present in TRC databases 
              on the date 2020-09-30. The /ThermoML/Browse route, linked above in the navigation gray bar, provides 
              browsing by journal issue or by property, collated for all journals, to the source of the data points. 
      
              A summary of all data point counts collected for each journal, and then overall journals, may be browsed below by property 
              group and name. 
    </b-card-text>
      <b-table
        hover
        :items="data_summary"
        :fields="fields"
        caption-top
        outlined
      >
      <template #cell(show_details)="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
          {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
        </b-button>
      </template>
        <template #row-details="row">
          <b-card-group deck>
            <property dset_type='pure' :group_property="row.item.details.pure"
            :search_button="false"/>
            <property dset_type='binary' :group_property="row.item.details.binary"
            :search_button="false"/>
            <property dset_type='ternary' :group_property="row.item.details.ternary"
            :search_button="false"/>
            <property dset_type='reaction' :group_property="row.item.details.reaction"
            :search_button="false"/>
          </b-card-group>
        </template>
      </b-table>
      </b-card>
    </div>
</template>

<script>
import axios from "axios";
import Property from '@/components/Property.vue'

export default {
  name: "TMLSummary",
  components: {
    Property
  },
  data() {
    return {
      fields: [
        { key: 'journal_abbr', label: 'Journal', variant:'info', isRowHeader: true},
        { key: 'data_sets'},
        { key: 'data_points'},
        { key: 'details.pure.data_sets', label: 'Pure Data Sets'},
        { key: 'details.pure.data_points', label: 'Pure Data Points'},
        { key: 'details.binary.data_sets', label: 'Binary Data Sets'},
        { key: 'details.binary.data_points', label: 'Binary Data Points'},
        { key: 'details.ternary.data_sets', label: 'Ternary Data Sets'},
        { key: 'details.ternary.data_points', label: 'Ternary Data Points'},
        { key: 'details.reaction.data_sets', label: 'Reaction Data Sets'},
        { key: 'details.reaction.data_points', label: 'Reaction Data Points'},
        { key: 'show_details'}
        ],
      journals: [
        "All Journals",
        "J. Chem. Eng. Data",
        "J. Chem. Thermodyn.",
        "Thermochim. Acta",
        "Fluid Phase Equilib.",
        "Int. J. Thermophys.",
      ],
      data_summary: [],
    };
  },
  methods: {
    fetchData() {
      axios.get("./jsons/data_summary_by_journal.json").then((response) => {
        let data_summary = [];
        this.journals.forEach( j => {
          let j_summary = response.data[j][0];
          j_summary['journal_abbr'] = j;
          data_summary.push(j_summary);
          }
        )
        this.data_summary = data_summary;
      });
    },
  },
  created() {
    // Fetch Data
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000000 !important;
}
</style>
